import React from "react";

const CircularProgress = ({ percentage }) => {
  const radius = 50;
  const stroke = 10;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  
  return (

    <div className="w-32 h-32 relative">
      <svg height={radius * 2} width={radius * 2} className="transform -rotate-90 ">
        {/* Background circle */}
        <circle stroke="#e5e7eb" fill="transparent" strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius}/>
        {/* Progress circle */}
        <circle stroke="#22BEFF" fill="transparent" strokeWidth={stroke} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} r={normalizedRadius} cx={radius} cy={radius}/>
      </svg>
      <div className="absolute top-[40%] left-[40%] translate-x-[-50%] translate-y-[-50%] text-center text-sm font-semibold text-[#00CAFF]">
        {percentage}%
      </div>
    </div>

  );
};

export default CircularProgress;
